//node_modules
import { useState } from "react";
import { Link } from "react-router-dom";
//style files
import logo from "../../assets/images/logo.png";

const Navbar = (props) => {
  const [toggle, setToggle] = useState(false);

  const OpenMenu = () => {
    setToggle(true);
    document.body.style.overflowY = "hidden";
  };
  const CloseMenu = () => {
    setToggle(false);
    document.body.style.overflowY = "auto";
  };

  return (
    <section className="w-full shadow-lg flex flex-row justify-center fixed bg-white z-50">
      <div className="w-4/5 max-w-screen-xl py-5 flex flex-row justify-between items-center space-x-3">
        <Link
          to="/"
          onClick={() => {
            window.scrollTo(0, 0);
          }}
          className="cursor-pointer"
        >
          <img src={logo} alt="bizz trip logo" width={130} />
        </Link>
        <div className="hidden lg:flex items-center">
          <ul className="flex flex-row space-x-3 2xl:space-x-7">
            <li className="text-sm xl:text-base whitespace-nowrap text-green-custom hover:text-yellow-400 uppercase font-medium flex items-center">
              <a
                href={
                  props.currentLang === "eng"
                    ? "/#what-is-bizztrip"
                    : "/#bizztrip-nedir"
                }
              >
                {props.currentLang === "eng"
                  ? "WHAT IS BIZZTRIP?"
                  : "BIZZTRIP NEDİR?"}
              </a>
            </li>
            <li className="text-sm xl:text-base whitespace-nowrap text-green-custom hover:text-yellow-400 uppercase font-medium flex items-center">
              <a
                href={
                  props.currentLang === "eng"
                    ? "/#who-can-apply"
                    : "/#kimler-basvurabilir"
                }
              >
                {props.currentLang === "eng"
                  ? "WHO CAN APPLY?"
                  : "KİMLER BAŞVURABİLİR?"}
              </a>
            </li>
            <li className="text-sm xl:text-base whitespace-nowrap text-green-custom hover:text-yellow-400 uppercase font-medium flex items-center">
              <a
                href={
                  props.currentLang === "eng" ? "/#schedule" : "/#program-akisi"
                }
              >
                {props.currentLang === "eng" ? "SCHEDULE" : "PROGRAM AKIŞI"}
              </a>
            </li>
            <li className="text-sm xl:text-base whitespace-nowrap text-green-custom hover:text-yellow-400 uppercase font-medium flex items-center">
              <a
                href={
                  props.currentLang === "eng" ? "/#speakers" : "/#konusmacilar"
                }
              >
                {props.currentLang === "eng" ? "SPEAKERS" : "KONUŞMACILAR"}
              </a>
            </li>
            <li className="text-sm xl:text-base whitespace-nowrap text-green-custom hover:text-yellow-400 uppercase font-medium flex items-center">
              <a href={props.currentLang === "eng" ? "/#faq" : "/#sss"}>
                {props.currentLang === "eng" ? "FAQ" : "S.S.S."}
              </a>
            </li>
          </ul>
        </div>
        <div className="hidden lg:flex items-center space-x-7">
          <a href={props.currentLang === "eng" ? "/#register" : "/#kayit-ol"}>
            <p className="text-md 2xl:text-lg font-bold text-white hover:text-yellow-400 bg-green-custom px-6 2xl:px-11 py-1 rounded-md whitespace-nowrap">
              {props.currentLang === "eng" ? "REGISTER" : "KAYIT OL"}
            </p>
          </a>
          <button
            onClick={() => {
              props.currentLang === "tr"
                ? props.setCurrentLang("eng")
                : props.setCurrentLang("tr");
            }}
            className="text-sm xl:text-base whitespace-nowrap text-green-custom uppercase font-medium select-none"
          >
            <span
              className={
                props.currentLang === "tr" ? "text-yellow-400 text-lg" : ""
              }
            >
              TR
            </span>
            /
            <span
              className={
                props.currentLang === "eng" ? "text-yellow-400 text-lg" : ""
              }
            >
              ENG
            </span>
          </button>
        </div>
        <div
          onClick={() => {
            OpenMenu();
          }}
          className="lg:hidden flex flex-col space-y-1 p-3"
        >
          <div className="w-6 h-1 bg-green-custom rounded-sm"></div>
          <div className="w-6 h-1 bg-green-custom rounded-sm"></div>
          <div className="w-6 h-1 bg-green-custom rounded-sm"></div>
        </div>
      </div>
      <div
        className={
          toggle
            ? "block w-4/5 h-screen1 fixed bg-white top-0 bottom-0 right-0 z-10 overflow-y-auto select-none transition-all duration-200"
            : "block w-4/5 h-screen1 fixed bg-white top-0 bottom-0 e-right-4_5 z-10  overflow-y-auto select-none transition-all duration-200"
        }
      >
        <div className="relative w-100 h-100 py-16">
          <div
            onClick={CloseMenu}
            className=" p-4 bg-white absolute top-8 right-9 flex justify-center items-center hover-bg-yellow-custom rounded-md transition-all duration-200"
          >
            <div className="w-8 h-1 bg-green-custom rounded-sm rotate-45 absolute"></div>
            <div className="w-8 h-1 bg-green-custom rounded-sm -rotate-45 absolute"></div>
          </div>
          <ul className="flex flex-col space-y-5 divide-y divide-green-900 pl-5">
            <li className="mx-2 pt-5">
              <a
                className="block w-100 h-100 text-green-custom text-2xl font-bold uppercase hover-text-yellow-custom focus-text-yellow-custom bg-white"
                onClick={CloseMenu}
                href={
                  props.currentLang === "eng"
                    ? "/#what-is-bizztrip"
                    : "/#bizztrip-nedir"
                }
              >
                {props.currentLang === "eng"
                  ? "WHAT IS BIZZTRIP?"
                  : "BIZZTRIP NEDİR?"}
              </a>
            </li>
            <li className="mx-2 pt-5">
              <a
                className="block w-100 h-100 text-green-custom text-2xl font-bold uppercase hover-text-yellow-custom focus-text-yellow-custom bg-white"
                onClick={CloseMenu}
                href={
                  props.currentLang === "eng"
                    ? "/#who-can-apply"
                    : "/#kimler-basvurabilir"
                }
              >
                {props.currentLang === "eng"
                  ? "WHO CAN APPLY?"
                  : "KİMLER BAŞVURABİLİR?"}
              </a>
            </li>
            <li className="mx-2 pt-5">
              <a
                className="block w-100 h-100 text-green-custom text-2xl font-bold uppercase hover-text-yellow-custom focus-text-yellow-custom bg-white"
                onClick={CloseMenu}
                href={
                  props.currentLang === "eng" ? "/#schedule" : "/#program-akisi"
                }
              >
                {props.currentLang === "eng" ? "SCHEDULE" : "PROGRAM AKIŞI"}
              </a>
            </li>
            <li className="mx-2 pt-5">
              <a
                className="block w-100 h-100 text-green-custom text-2xl font-bold uppercase hover-text-yellow-custom focus-text-yellow-custom bg-white"
                onClick={CloseMenu}
                href={
                  props.currentLang === "eng" ? "/#speakers" : "/#konusmacilar"
                }
              >
                {props.currentLang === "eng" ? "SPEAKERS" : "KONUŞMACILAR"}
              </a>
            </li>
            <li className="mx-2 pt-5">
              <a
                className="block w-100 h-100 text-green-custom text-2xl font-bold uppercase hover-text-yellow-custom focus-text-yellow-custom bg-white"
                onClick={CloseMenu}
                href={props.currentLang === "eng" ? "/#faq" : "/#sss"}
              >
                {props.currentLang === "eng" ? "FAQ" : "S.S.S."}
              </a>
            </li>
            <li className="mx-2 pt-5">
              <a
                className="block w-100 h-100 text-green-custom text-2xl font-bold uppercase hover-text-yellow-custom focus-text-yellow-custom bg-white"
                onClick={CloseMenu}
                href={props.currentLang === "eng" ? "/#register" : "/#kayit-ol"}
              >
                {props.currentLang === "eng" ? "REGISTER" : "KAYIT OL"}
              </a>
            </li>
            <li className="mx-2 pt-5">
              <button
                onClick={() => {
                  props.currentLang === "tr"
                    ? props.setCurrentLang("eng")
                    : props.setCurrentLang("tr");
                  CloseMenu();
                }}
                className="text-xl whitespace-nowrap text-green-custom uppercase font-medium select-none"
              >
                <span
                  className={
                    props.currentLang === "tr" ? "text-yellow-400" : ""
                  }
                >
                  TR
                </span>
                /
                <span
                  className={
                    props.currentLang === "eng" ? "text-yellow-400" : ""
                  }
                >
                  ENG
                </span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Navbar;
